var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              staticClass: "modal_medium",
              attrs: { persistent: "" },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: {
                        method: "post",
                        enctype: "multipart/form-data",
                        "lazy-validation": "",
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c("v-card-title", [
                        _c("span", { staticClass: "headl" }, [
                          _vm._v("BORRAR ESTRATO"),
                        ]),
                      ]),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", sm: "12", md: "12" },
                                    },
                                    [
                                      _c("div", { staticClass: "del_ctn" }, [
                                        _c("p", [
                                          _vm._v(
                                            " Está a punto de eliminar el estrato con nombre "
                                          ),
                                          _c("b", [
                                            _vm._v(_vm._s(_vm.data.name)),
                                          ]),
                                          _vm._v(
                                            ", si la acción es correcta digite el nombre, recuerde que esto es irreversible y no podrá recuperar la información. "
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", sm: "12", md: "12" },
                                    },
                                    [
                                      _c("v-text-field", {
                                        ref: "name",
                                        attrs: {
                                          rules: [
                                            _vm.nameRules.required,
                                            _vm.nameRules.equal,
                                          ],
                                          label: "Nombre del estrato",
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.name,
                                          callback: function ($$v) {
                                            _vm.name = $$v
                                          },
                                          expression: "name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "div",
                            { staticClass: "ctn_btn_shop" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { large: "", text: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      _vm.show = false
                                    },
                                  },
                                },
                                [_vm._v("Cerrar")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn_delete",
                                  attrs: {
                                    disabled: !_vm.valid,
                                    depressed: "",
                                    large: "",
                                  },
                                  on: { click: _vm.validate },
                                },
                                [_vm._v("Eliminar")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }